module.exports = __webpack_public_path__ + "img/2025-05-09b_3.c137f494.jpg";